export default __webpack_public_path__ + "static/media/portfolio1.30ca1f3c.webp";